import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  CompanyMinimalFragment,
  GroupFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { BuildingIcon } from "../../icons";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

interface GroupUpdatedActivityProps {
  activity: GroupUpdatedActivity;
}

type GroupUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: GroupFragment;
};

export function isGroupUpdatedActivity(
  q: ActivityFragment
): q is GroupUpdatedActivity {
  return q.key === "group.updated";
}

interface GroupUpdatedActivityProps {
  activity: GroupUpdatedActivity;
}

export const GroupUpdatedActivity: React.FC<GroupUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="groupUpdatedActivity"
      visual={<BuildingIcon className="w-10 h-10 text-accent-500" />}
    >
      <Text fontSize="sm">
        {t("activity.labels.groupUpdated", {
          group: (
            <Link to={`/users?groupId=${activity.trackable.id}`}>
              {activity.trackable.name}
            </Link>
          ),
        })}
      </Text>
    </Activity>
  );
};
